import can from 'can';

import template from './disable-alert.stache';

export default can.Component.extend({
    tag: 'alert-manager-disable-alert',
    template,
    viewModel: {
        define: {
            isAlertsDisable: {
                type: 'boolean',
                value: false,
            },
        },
    },
    events: {
        '.js-close-button click'() {
            if (this.viewModel.isAlertsDisable) {
                this.viewModel.dispatch('onAlertsDisable');
            }
            this.viewModel.dispatch('onCloseClick');
        },
        '.js-checkbox click'() {
            this.viewModel.attr(
                'isAlertsDisable',
                !this.viewModel.attr('isAlertsDisable'),
            );
        },
    },
});
